// extracted by mini-css-extract-plugin
export default {"body":"ui5Hrd4Z","mobile":"mobile","email":"QjemzFl3","emailChange":"JoV9mQgI"};